import { ActionsUnion } from "../../type/actionsUnion"
import createAction from "../../type/createAction"
import { StoreState } from "../StoreState"

export type EEnvironment = "Production" | "Sandbox" | "QA" | "Betatest" | "Test" | "Test2" | "Development"

export type ConfigurationState = Readonly<{
    environment?: EEnvironment
}>
const initialState: ConfigurationState = { environment: undefined }

export const configurationReducerActions = {
    setEnvironment: (environment: EEnvironment) => createAction("APP/SET_ENVIRONMENT", { environment }),
}

export type ConfigurationActions = ActionsUnion<typeof configurationReducerActions>

export const configurationReducer = (state: ConfigurationState = initialState, action: ConfigurationActions) => {
    switch (action.type) {
        case "APP/SET_ENVIRONMENT": {
            return {
                ...state,
                environment: action.environment,
            }
        }
    }

    return state
}

export const configurationSelectors = {
    environment: (state: StoreState) => state.configuration.environment,
}
